import { IQualification, QualificationModel } from "@core/models";

export const qualificationsMocks = [
  {
    [IQualification.qualificationId]: 1,
    [IQualification.qualificationLabel]: "Resp de salle",
    [IQualification.familyLabel]: "Salle/Bar",
  },
  {
    [IQualification.qualificationId]: 2,
    [IQualification.qualificationLabel]: "Serveur",
    [IQualification.familyLabel]: "Salle/Bar",
  },
  {
    [IQualification.qualificationId]: 3,
    [IQualification.qualificationLabel]: "Employé polyvalent",
    [IQualification.familyLabel]: "Retail",
  },
  {
    [IQualification.qualificationId]: 5,
    [IQualification.qualificationLabel]: "Hôtesse / Accueil",
    [IQualification.familyLabel]: "Hôtel",
  },
].map((qualification) => new QualificationModel(qualification));

export const qualificationMock = qualificationsMocks[0];
